import BvWrapper from './code/Scripts/Components/BvWrapper.vue';

export default {
  components: {
    BvWrapper,
  },
};
